import { Signin } from "views/auth/signin";
import { ForgotPassword } from "views/auth/signin/forgotpassword";
import { ImpersonateSignin } from "views/auth/signin/impersonate";
import { MagicSignin } from "views/auth/signin/magic";
import { SigninOTP } from "views/auth/signin/otp";
import { ResetPassword } from "views/auth/signin/resetpassword";
import { SignupUser } from "views/auth/signup/user";

const Routes = [
  {
    path: "/admin/signup/user",
    view: SignupUser,
    layout: "auth",
    title: "Sign up to Cover Badger Admin",
  },
  {
    path: "/",
    view: Signin,
    layout: "auth",
    title: "Welcome to Cover Badger Admin",
  },
  {
    path: "/admin/",
    view: Signin,
    layout: "auth",
    title: "Welcome to Cover Badger Admin",
  },
  {
    path: "/admin/signin/otp",
    view: SigninOTP,
    layout: "auth",
    title: "Enter verification code",
  },
  {
    path: "/admin/magic",
    view: MagicSignin,
    layout: "auth",
    title: "Sign In",
  },
  {
    path: "/admin/forgotpassword",
    view: ForgotPassword,
    layout: "auth",
    title: "Forgot Your Password?",
  },
  {
    path: "/admin/resetpassword",
    view: ResetPassword,
    layout: "auth",
    title: "Reset Your Password",
  },
  {
    path: "/admin/signin/impersonate",
    view: ImpersonateSignin,
    layout: "auth",
    title: "Sign in via Mission Control",
  },
];

export default Routes;
